import React, { FC } from 'react'
import { Column } from '@components/UI-Components/HierarchyWiseItemsTable/models/column'
import * as css from './QuantityHeaderWithKPI.css'
import QuantityKPICell from './QunatityKPICell'
import { useTranslation } from 'react-i18next'

export interface CellProps {
  column?: Column
  customClass?: any
}

const QuantityHeaderWithKPI: ({ headers, doorOrderId }) => FC<CellProps> =
  ({ headers, doorOrderId }) =>
  ({ column }) => {
    const { label, key } = column
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTranslation()
    return headers?.length ? (
      <>
        {headers.map(header => (
          <QuantityKPICell header={header} doorOrderId={doorOrderId} />
        ))}
        <div className={css.cellWrapper}>
          <span className={css.cell}>
            {key ? t(`order.listview.colHeader.${key}`, label) : label}
          </span>
        </div>
      </>
    ) : (
      <span className={css.cell}>
        {key ? t(`order.listview.colHeader.${key}`, label) : label}
      </span>
    )
  }

export default QuantityHeaderWithKPI
